import React, { Component } from "react";
import printBorder from "../../public/assets/images/trapezoid.png";
class PrintQr extends Component {
  render() {
    return (
      <div className="mt-4 d-flex flex-column justify-content-between align-items-center">
        <div
          style={{
            margin: 20,
            paddingTop: "20",
            marginLeft: 400,
            paddingRight: 400,
            backgroundImage: `url(${printBorder})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: 550
          }}
          className=" d-flex flex-column justify-content-around align-items-center"
        >
          {this.props.qrImage}
          <img src={this.props.logo} className="img-fluid" alt="" width="150" />
        </div>
        <div
          style={{
            transform: "rotate(180deg)",
            margin: 20,
            paddingTop: "20",
            marginRight: 400,
            paddingRight: 400,
            backgroundImage: `url(${printBorder})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: 550
          }}
          className="d-flex flex-column justify-content-around align-items-center"
        >
          {this.props.qrImage}
          <img src={this.props.logo} className="img-fluid" alt="" width="150" />
        </div>
      </div>
    );
  }
}

export default PrintQr;



// WEBPACK FOOTER //
// ./src/components/printQr.js